import { CSSProperties, ReactElement } from "react";
import { Paper } from "@mui/material";

interface IProps {
  title: string;
  subTitle?: string;
  children: ReactElement;
  valueBgColor?: string;
}

const titleCellStyle = (): CSSProperties => ({
  padding: ".5em",
  alignSelf: "stretch",
  gridColumn: "1 / span 1",
  borderRadius: 5,
  background: "rgba(50, 50, 50, .3)"
});


const ColComponent = ({ title, subTitle, children }: IProps) => {
  return (
    <div className="display-flex-column flex-grow-1">
      <Paper elevation={0}  style={titleCellStyle()} className="display-grid" >
        <div className="align-self-center justify-self-center display-flex-column">
          <strong>{title}</strong>
          {subTitle && <small>{subTitle}</small>}
        </div>
      </Paper>
      <div className="flex-grow-1">
        {children}
      </div>
    </div>
  );
};

export default ColComponent;
